import { useTranslation } from "react-i18next";
import { useLocation } from "../../hooks/useRoutes";
import useTemplateList from "../../hooks/useTemplateList";
import useGoogleFonts from "../../SPA/hooks/useGoogleFonts";
import { templateFontList } from "../../SPA/Components/EditTemplateProduct/common";
import React, { useMemo, useState } from "react";
import { getAllUrlParams } from "../../../lib/common";
import useTemplateFilters from "../../hooks/useTemplateFilters";
import useFilteredTemplateList from "../../SPA/hooks/useFilteredTemplateList";
import SubHeader from "../../SPA/Components/SubHeader";
import FiltersDialog from "../../SPA/Components/Template/FiltersDialog";
import TypeOptions from "./TypeOptions";
import ProductsWithTemplates from "./ProductsWithTemplates";
const CalendarListPageContent = ({ category, }) => {
    const type = "calendars";
    const [t] = useTranslation();
    const location = useLocation();
    const [templateList, loadingTemplates] = useTemplateList(type, category);
    const { loaded: fontsLoaded } = useGoogleFonts(templateFontList);
    // Get params as an object:
    const params = useMemo(() => {
        // Hack to trigger a scroll event (For templates to show)
        window.scrollTo(window.scrollX, window.scrollY - 1);
        window.scrollTo(window.scrollX, window.scrollY + 1);
        return getAllUrlParams(location.search);
    }, [location]);
    const filterOptions = useMemo(() => {
        return {
            filters: ["formats", "pages"],
            predef: params,
        };
    }, [params]);
    const [filters, toggleFilterOption] = useTemplateFilters(templateList, filterOptions);
    const filteredTemplates = useFilteredTemplateList(templateList, filters);
    const [filtersOpen, setFiltersOpen] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(SubHeader, { title: t("Calendars"), subtitle: t("Choose template") || "" }),
        React.createElement(TypeOptions, { setFiltersOpen: setFiltersOpen, filters: filters, toggleFilterOption: toggleFilterOption }),
        React.createElement(ProductsWithTemplates, { loading: loadingTemplates || !fontsLoaded, type: type, category: category, templates: filteredTemplates, canViewWithOwnPictures: true, separateFromBackground: false }),
        filtersOpen && (React.createElement(FiltersDialog, { filters: filters, toggleFilterOption: toggleFilterOption, templates: templateList.templates, filteredTemplates: filteredTemplates, onClose: () => setFiltersOpen(false), onOpen: () => setFiltersOpen(true) }))));
};
export default CalendarListPageContent;
